export function handleModal(modalWrapper){
    const modalClose=modalWrapper.querySelector('.modal-close-wrapper');
    if(!modalClose) return;

    modalClose.addEventListener('click', ()=>{
        document.body.style.overflow='unset';
        modalWrapper.classList.remove('active');
    })
}

const modals=document.querySelectorAll('.modal');

for(const modal of modals){
    handleModal(modal)
}
